const companyUrl = process.env.REACT_APP_COMPANY_API;

export const GET_FTS_MAPPING_URL = `${companyUrl}/v1/fts-mapping`;
